// extracted by mini-css-extract-plugin
export default {"menu":"dZ25o","item":"ED86t","itemActive":"Sl1dU","icon":"mIW54","text":"xgLi0"};